import {graneroInstance} from './index.js';

export const getProjectionDef = (epsgCode, options) => {
  const url = `/geometry/proj?epsg=${epsgCode}`;
  return graneroInstance.get(url, options).then(r => r.data);
};
